import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * This route is no longer used. The real payment flow goes through /Payment1,
 * which collects customer details and redirects to the Thawani gateway.
 * Anyone landing here is sent back to the home page.
 */
const Payment = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/', { replace: true });
  }, [navigate]);

  return null;
};

export default Payment;
